import { createClient, createAdminClient } from "@sdk/core";
import { getTenantId } from "@shared/lib/auth";
import {
  buildAdminErrorDiagnostic,
  logAdminErrorDiagnostic,
} from "@shared/lib/errorDiagnostics";

const cache: Record<string, number> = {};
const ONE_HOUR = 1000 * 60 * 60;

function shouldReport(key: string) {
  const now = Date.now();
  if (cache[key] && now - cache[key] < ONE_HOUR) return false;
  cache[key] = now;
  return true;
}

function normalizeStack(input: string) {
  try {
    let s = input || "";
    s = s.replace(/https?:\/\/[^\s)]+/g, (m) => {
      try {
        const u = new URL(m);
        return `${u.origin}${u.pathname}`;
      } catch {
        return m;
      }
    });
    s = s.replace(/:\d+:\d+/g, ":_:_");
    return s;
  } catch {
    return input;
  }
}

async function sendError(err: any) {
  const diagnostic = buildAdminErrorDiagnostic(err, "window-error");
  logAdminErrorDiagnostic(diagnostic, err);

  const message = err?.message || String(err);
  const rawStack = err?.stack || "no-stack";
  const stack = normalizeStack(rawStack);
  const key = `${message}|${stack}`;
  if (!shouldReport(key)) return;

  try {
    const http = createClient({ baseUrl: "/", getTenantId });
    const admin = createAdminClient(http) as any;
    const release =
      (import.meta as any).env?.VITE_RELEASE ||
      (typeof process !== "undefined"
        ? (process.env as any)?.VITE_RELEASE
        : undefined) ||
      undefined;
    await admin.metrics.errors({
      message,
      stack,
      path: diagnostic.route,
      ts: diagnostic.timestamp,
      release,
      requestId: diagnostic.correlationId,
      tenantSlug: diagnostic.tenantSlug,
      route: diagnostic.route,
      failingApi: diagnostic.failingApi,
      httpStatus: diagnostic.httpStatus,
    });
  } catch {}
}

export function initErrorReporting() {
  window.addEventListener("error", (event) => {
    sendError((event as any).error || (event as any).message);
  });
  window.addEventListener("unhandledrejection", (event) => {
    sendError((event as any).reason || "unhandled rejection");
  });
}
